import Transactions from "./index";
export default [
    {
      path: "/transactions",
      component: Transactions,
      name: "Transactions",
    },
  
  ];